/* eslint-disable no-template-curly-in-string */

export const LocaleJP = {
  mixed: {
    default: '${path}は無効です',
    required: '必須項目です',
  },
  string: {
    matches: '${path}は次と一致する必要があります: "${regex}"',
    email: 'メールアドレス形式で入力してください',
    url: 'URLを入力してください',
  },
}
